import { types } from './listcampaign.type';

export const getListCampaign = () => {
  return {
    type: types.GET_LIST_CAMPAIGNS,
  }
}